import React, { useState, useEffect } from 'react';
import MainLogo from "../../assets/img/logo.png";

const Preloader = () => {
  return (
    <div className='preloader'>
      {/* Loader Image */}
      <div className='loader-box text-center'>
        {/* <img className='loader-obj' src={MainLogo} alt='MainLogo' /> */}
        <div className='loading-cricle'></div>
        <h5>Loading... Just a moment!</h5>
      </div>
    </div>
  );
};

export default Preloader;